export default __webpack_public_path__ + "static/media/bg-polipromotion.1c5a7b05.png";